// Tiny shared helper kept dependency-free so both the core shell and the
// landing/page modules can import it without creating an import cycle.

export interface MmUser {
  id?: number;
  provider?: string;
  avatar?: string | null;
  isAdmin?: boolean;
  name: string;
  email: string;
  plan?: 'free' | 'premium';
  tier?: string;
  billing?: string;
  trialEnd?: number | null;
  hdType?: string;
  birth?: string;
  btime?: string;
  place?: string;
  interests?: string[];
  prefs?: Record<string, boolean>;
}

export function mmIsPremium(user: MmUser | null | undefined): boolean {
  return !!(user && user.plan === 'premium' && (!user.trialEnd || Date.now() < user.trialEnd));
}

/**
 * Why access lapsed, or null if it has not.
 *
 * `trialEnd` carries two different things: the end of the free 3-day trial and
 * the end of a period a customer paid for (applyPaidPlan sets it to +30 days
 * for Gold, +365 for Premium). Only `tier` tells them apart, so telling someone
 * who paid ฿3,542 that their "3-day trial expired" is wrong — hence this split.
 */
export function mmLapsed(user: MmUser | null | undefined): 'trial' | 'paid' | null {
  if (!user || user.plan !== 'premium' || !user.trialEnd) return null;
  if (Date.now() < user.trialEnd) return null;
  return user.tier && user.tier !== 'Trial' ? 'paid' : 'trial';
}
